"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KoraLabsProvider = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const HandleClient_class_1 = require("../HandleClient.class");
const HandleClientProvider_abstract_class_1 = require("./HandleClientProvider.abstract.class");
const types_1 = require("../../types");
/**
 * KoraLabsProvider class that extends HandleClientProvider and
 * provides methods to interact with the Handle.me API.
 *
 * @extends {HandleClientProvider}
 */
class KoraLabsProvider extends HandleClientProvider_abstract_class_1.HandleClientProvider {
    /**
     * Creates an instance of the KoraLabsProvider.
     *
     * @param {string} [headerKey] - Optional API key for the Handle.me API.
     */
    constructor(network, headerKey) {
        super();
        this.network = network;
        /** Request headers for the API. */
        this.headers = new Headers({
            'Content-Type': 'application/json'
        });
        /** Name of the API key header. */
        this.API_KEY_NAME = 'HANDLE_ME_API_KEY';
        /**
         * Retrieves the Cardano address for a given handle.
         *
         * @param {HEX} handle - The handle to lookup, in HEX format.
         * @returns {Promise<string>} - A promise that resolves to the Cardano address.
         */
        this.getCardanoAddress = (handle) => __awaiter(this, void 0, void 0, function* () {
            const name = HandleClient_class_1.HandleClient.getNormalizedName(handle);
            const { resolved_addresses } = yield this.__handleResponse((0, cross_fetch_1.default)(`${this.apiUrl}/handles/${name.value}`, {
                headers: this.headers
            }), name);
            return resolved_addresses.ada;
        });
        /**
         * Retrieves the Bitcoin address for a given handle.
         *
         * @param {HEX} handle - The handle to lookup, in HEX format.
         * @returns {Promise<string|undefined>} - A promise that resolves to the Bitcoin address, or undefined if not found.
         */
        this.getBitcoinAddress = (handle) => __awaiter(this, void 0, void 0, function* () {
            const name = HandleClient_class_1.HandleClient.getNormalizedName(handle);
            const { resolved_addresses } = yield this.__handleResponse((0, cross_fetch_1.default)(`${this.apiUrl}/handles/${name.value}`, {
                headers: this.headers
            }), name);
            return resolved_addresses === null || resolved_addresses === void 0 ? void 0 : resolved_addresses.btc;
        });
        /**
         * Retrieves the Ethereum address for a given handle.
         *
         * @param {HEX} handle - The handle to lookup, in HEX format.
         * @returns {Promise<string|undefined>} - A promise that resolves to the Ethereum address, or undefined if not found.
         */
        this.getEthereumAddress = (handle) => __awaiter(this, void 0, void 0, function* () {
            const name = HandleClient_class_1.HandleClient.getNormalizedName(handle);
            const { resolved_addresses } = yield this.__handleResponse((0, cross_fetch_1.default)(`${this.apiUrl}/handles/${name.value}`, {
                headers: this.headers
            }), name);
            return resolved_addresses === null || resolved_addresses === void 0 ? void 0 : resolved_addresses.eth;
        });
        /**
         * Retrieves all data associated with a given handle.
         *
         * @param {HEX} handle - The handle to lookup, in HEX format.
         * @returns {Promise<IHandle>} - A promise that resolves to the handle data.
         */
        this.getAllData = (handle) => __awaiter(this, void 0, void 0, function* () {
            const name = HandleClient_class_1.HandleClient.getNormalizedName(handle);
            return this.__handleResponse((0, cross_fetch_1.default)(`${this.apiUrl}/handles/${name.value}`, {
                headers: this.headers
            }), name);
        });
        /**
         * Retrieves all personalized data associated with a given handle.
         *
         * @param {HEX} handle - The handle to lookup, in HEX format.
         * @returns {Promise<IPersonalization>} - A promise that resolves to the handle data.
         *
         * @example
         * {
         *  "validated_by": "0x4da965a049dfd15ed1ee19fba6e2974a0b79fc416dd1796a1f97f5e1",
         *  "trial": false,
         *  "nsfw": false,
         *  "designer": {
         *      "bg_color": "0x8600ffbd",
         *      "creator_defaults_enabled": 0,
         *      "bg_border_color": "0xff5400e0",
         *      "font_shadow_color": "0x100202ff",
         *      "font_shadow_size": [9, 8, 8],
         *      "text_ribbon_colors": ["0x4858ffff"]
         *  }
         * }
         */
        this.getPersonalizedData = (handle) => __awaiter(this, void 0, void 0, function* () {
            const name = HandleClient_class_1.HandleClient.getNormalizedName(handle);
            return this.__handleResponse((0, cross_fetch_1.default)(`${this.apiUrl}/handles/${name.value}/personalized`, {
                headers: this.headers
            }), name);
        });
        this.apiUrl = `https://${network === types_1.HandleClientContext.MAINNET ? '' : `${types_1.HandleClientContext[network].toLowerCase()}.`}api.handle.me`;
        headerKey && this.headers.append(this.API_KEY_NAME, headerKey);
    }
}
exports.KoraLabsProvider = KoraLabsProvider;
